import psHttp from '@patsnap/common-ps-http';
import { coreBasicApiUrlPrefix } from '../../config/constants';

export function extractSequenceApi(query) {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/shortener/shorten`,
        method: 'POST',
        data: {
            query
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function getRealQueryApi(id) {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/shortener/original/${id}`,
        method: 'GET',
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}
